// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"acd4f0de0f3d546be1fe","655":"c16928fec031cd68ebe6"}[chunkId] + ".js";
};